let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dRIP5")).then(() => parcelRequire('dQ2Jo'));